<template>
  <div class="boxlogin">
    <h2 class="login-title">Log in to DROPSMART</h2>
    <b-form
      style="text-align: left"
      ref="loginForm"
      autocomplete="off"
      @submit.prevent="submitLogin"
    >
      <!-- E-mail Input -->
      <b-input-group class>
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          type="email"
          name="email"
          class="LoginInput"
          size="lg"
          placeholder="E-MAIL"
          v-model="$v.formLogin.email.$model"
          :state="validateInput('email')"
          aria-describedby="email-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="email-feedback" v-bind:tooltip="false"
          >Must be a valid email address.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- Password Input -->
      <b-input-group class>
        <span class="formIcons password">
          <PasswordIcon />
        </span>
        <b-form-input
          class="LoginInput"
          size="lg"
          type="password"
          name="password"
          v-model="$v.formLogin.password.$model"
          :state="validateInput('password')"
          placeholder="PASSWORD"
          aria-describedby="password-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="password-feedback" v-bind:tooltip="false">
          Your password must be at least 6 characters.
        </b-form-invalid-feedback>
      </b-input-group>
      <b-alert variant="error" v-model="formLogin.loginAuthError">Invalid e-mail or password</b-alert>
      <button class="button-login" type="submit" id="submitLogin">
        <b-spinner v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">LOG IN</span>
      </button>
    </b-form>
    <a href="/forgot-password" class="forgot-password">Forgot your password?</a>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import PasswordIcon from "./icons/PasswordIcon.vue";
import EmailIcon from "./icons/EmailIcon.vue";
import { BACKEND_URL } from "../config.js";

export default {
  mixins: validationMixin,
  components: {
    PasswordIcon,
    EmailIcon,
  },
  validations: {
    formLogin: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  data() {
    return {
      showLoad: false,
      formLogin: {
        email: null,
        password: null,
        loginAuthError: false,
      },
    };
  },
  computed: {
    validLoginForm: function () {
      return !this.$v.formLogin.$anyError;
    },
  },
  methods: {
    validateInput(name) {
      const { $dirty, $error } = this.$v.formLogin[name];
      return $dirty ? !$error : null;
    },
    submitLogin() {
      console.log('clicked on submit');
      this.$v.formLogin.$touch();
      if (!this.validLoginForm) {
        console.log('bailing out because the form is invalid.');
        return;
      }

      this.showLoad = true;
      this.formLogin.loginAuthError = false;

      console.log("Submiting login to " + BACKEND_URL.Login);
      fetch(BACKEND_URL.Login, {
        method: "POST",
        body: JSON.stringify(this.formLogin),
        headers: {
          "Content-type": "application/json",
        },
        credentials: "same-origin",
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status == 401) {
              this.formLogin.loginAuthError = true;
            }
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .then((loginResponse) => {
          this.showLoad = false;
          let jsonInfo = JSON.stringify(loginResponse);
          sessionStorage.setItem(
            "customerInfo",
            jsonInfo
          );
          //console.log('LoginForm: customerInfo from session: ' + sessionStorage.getItem("customerInfo"));
          //console.log('Just the PAID attribute: ' + JSON.parse(sessionStorage.getItem("customerInfo")).user.paid);

          if(this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect)
          }else{
              this.$router.push( { name: "DropsmartCentre" })
          }
        })
        .catch((error) => {
          this.showLoad = false;
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss">
main {
  overflow-x: hidden;
  height: 100%;
}
.boxlogin {
  padding: 0 15px;
  text-align: center;
  .forgot-password {
    color: #666666;
    font-size: 13px;
    width: 100%;
  }
}
.login-title {
  color: #000000;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 0;
  padding: 0px 0 40px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
form {
  margin-bottom: 15px;
}
.button-login {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  margin-top: 8px;
  padding: 0 15px;
  text-transform: uppercase;
  width: 100%;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
</style>